import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { transitions } from 'polished';
import Container from '../Container';
import { H3 } from '../Heading';
import Link from '../Links';
import CategoryLabel from '../ResourceCategoryLabel';
import { ReactComponent as PlusSvg } from '../../svg/plus.svg';
import { ReactComponent as HRSvg } from '../../svg/underline.svg';

const ResourceListingItemStyled = styled.div`
  width: 100%;
  font-size: 0.8em;
  margin: 0 auto 1em;
  position: relative;
  height: 40rem;
  overflow: hidden;
  margin: 2em auto;
  display: ${({ isOpen }) => (!!isOpen ? 'block' : 'none')};
`;

const LabelContainer = styled.button`
  width: 100%;
  margin: 0 auto 2em;
  display: block;
  cursor: pointer;
  appearance: none;
  border: 0;
  background: ${props => props.theme.colors.white};
  padding: 0.5em;
`;

const CollapsibleLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Label = styled(H3)`
  margin-bottom: 0;
  line-height: 1;
`;

const PlustContainer = styled.div`
  svg {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(0)')};
    ${props => transitions(['transform'], props.theme.animations.ease)}

    path {
      &:first-child {
        opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
      }
    }
  }
`;

const PlusStyled = styled(({ isOpen, ...props }) => <PlusSvg {...props} />)`
  width: 1.6em;
  height: auto;
  color: ${props =>
    !!props.isOpen
      ? props.theme.colors.darkChocolate
      : props.theme.colors.briangerine};

  path {
    ${props => transitions(['opacity', 'color'], props.theme.animations.ease)}
  }
`;
const ResourceListingStyled = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const ResourceButton = styled(Link)`
  color: ${({ theme }) => theme.colors.briangerine};
  font-size: 1.4rem;
  font-weight: 600;
  font-style: italic;
  text-transform: uppercase;
`;

const StyledImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transform: scale(1.075);
  transition: transform 0.4s;
  object-fit: cover;
`;

const StyledLinkContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 1em;
  ${props => !props.active && 'cursor: not-allowed;'}
  // color: inherit;
  text-decoration: none;


  /* ${StyledImage} {
    ${props => !props.active && 'opacity: 0.3;'}
  } */

  &:hover {
    text-decoration: none;
    color: inherit;
    ${StyledImage} {
      ${props => props.active && 'transform: scale(1);'}
    }
  }
`;

const HRStyled = styled(HRSvg)`
  width: 100%;
  color: ${props => props.theme.colors.briangerine};
`;

const BrandscaleTitle = styled(H3)`
  padding: 0 2rem;
  color: ${props =>
    props.titleColor === 'white'
      ? props.theme.colors.white
      : props.theme.colors.merciless};
`;

const CollapsedCollection = styled.div`
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  transform: ${({ isOpen }) => (isOpen ? `translateY(0)` : `translateY(3em)`)};
  height: ${({ isOpen }) => (isOpen ? 'auto' : '0')};
  ${({ theme }) =>
    transitions(['opacity', 'transform', 'height'], theme.animations.ease)}
`;

const ResourceListingItem = ({ isOpen, resource }) => {
  const { description, titleColor, linkLabel, thumbnail, url } = resource;

  return (
    <ResourceListingItemStyled isOpen={isOpen}>
      <StyledLinkContainer
        href={url}
        unstyled
        target="_blank"
        active={url}
        isExternal
      >
        {thumbnail && <StyledImage src={thumbnail} />}
        {linkLabel ? (
          <CategoryLabel category={linkLabel} url={url} />
        ) : (
          <span></span>
        )}
        <BrandscaleTitle titleColor={titleColor}>{description}</BrandscaleTitle>
      </StyledLinkContainer>
    </ResourceListingItemStyled>
  );
};

const ResourceListing = props => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container>
      <LabelContainer onClick={() => setIsOpen(!isOpen)}>
        <CollapsibleLabel>
          {props.fields.heading && <Label>{props.fields.heading}</Label>}
          <PlustContainer isOpen={isOpen}>
            <PlusStyled isOpen={isOpen} />
          </PlustContainer>
        </CollapsibleLabel>
        <HRStyled />
      </LabelContainer>
      <CollapsedCollection isOpen={isOpen}>
        <ResourceListingStyled>
          {props.fields.resources &&
            [...props.fields.resources].map(resource => (
              <ResourceListingItem
                key={`resource-listing-item-${resource.adminTitle.replace(
                  /\s+/g,
                  '-'
                )}`}
                isOpen={isOpen}
                resource={resource}
              />
            ))}
        </ResourceListingStyled>
      </CollapsedCollection>
    </Container>
  );
};

export default ResourceListing;
